import { apiFormData } from "../helpers/axios";
import api from "../helpers/axios";

class FileWithRagService {

    async uploadFileInBlob(formData) {
        try {
            const url = `${process.env.REACT_APP_AZURE_FUNCTION_URL}`;
            const response = await apiFormData({
                method: "POST",
                url,
                data: formData
            });
            return response;
        } catch (error) {
            console.log("Error uploadFileInBlob: ", error);
        }
    }

    async getPublicUrlOfFile(blobUrlObj) {
        try {
            const url = `/blob/generate_sas_url`;
            const publicUrlOfChatFile = await api.post(url, blobUrlObj);
            return publicUrlOfChatFile.data;
        } catch (error) {
            console.log("Error getPublicUrlOfChatFile: ", error);
        }
    }

}

export default new FileWithRagService();

